import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const calendarEmployeeFollowUpEventApiUrl = `${baseApiUrl}/api/Calendar`;

export async function getCalendarEmployeeFollowUpEventList(
  eventType = "",
  done = "",
  month,
  year
) {
  return await httpRequest(
    fetchCalendarEmployeeFollowUpEvents.bind(this, eventType, done, month, year)
  );
}
async function fetchCalendarEmployeeFollowUpEvents(
  eventType,
  done,
  month,
  year
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${calendarEmployeeFollowUpEventApiUrl}/month?EventTypeName=${eventType}&Done=${done}&Month=${month}&Year=${year}`,
    config
  );
}

export async function getCalendarYearEmployeeFollowUpEventList(
  eventType,
  done,
  year
) {
  return await httpRequest(
    fetchCalendarYearEmployeeFollowUpEvents.bind(
      this,
      eventType ?? "",
      done ?? "",
      year
    )
  );
}
async function fetchCalendarYearEmployeeFollowUpEvents(eventType, done, year) {
  let config = getHttpHeaders();
  return await axios.get(
    `${calendarEmployeeFollowUpEventApiUrl}/year?EventTypeName=${eventType}&Done=${done}&Year=${year}`,
    config
  );
}

export async function getCalendarDoneEmployeeFollowUpEventList(
  eventType,
  done,
  month,
  year,
  panelMode
) {
  return await httpRequest(
    fetchCalendarDoneEmployeeFollowUpEvents.bind(
      this,
      eventType ?? "",
      done ?? "",
      month,
      year,
      panelMode
    )
  );
}
async function fetchCalendarDoneEmployeeFollowUpEvents(
  eventType,
  done,
  month,
  year,
  panelMode
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${calendarEmployeeFollowUpEventApiUrl}?EventTypeName=${eventType}&Done=${done}&Month=${month}&Year=${year}&PanelMode=${panelMode}`,
    config
  );
}

export async function updateCalendarEmployeeFollowUpEvent(followUpEvent) {
  return await httpRequest(
    putCalendarEmployeeFollowUpEvent.bind(this, followUpEvent)
  );
}

async function putCalendarEmployeeFollowUpEvent(followUpEvent) {
  let config = getHttpHeaders();
  return await axios.put(
    `${calendarEmployeeFollowUpEventApiUrl}`,
    followUpEvent,
    config
  );
}
